export default "__VITE_PUBLIC_ASSET__732f87c9__"